module.exports = __webpack_public_path__ + "img/liven.ae2bd430.png";